import { render, staticRenderFns } from "./KBInvoicesBrands.vue?vue&type=template&id=686f5f4b&"
import script from "./KBInvoicesBrands.vue?vue&type=script&lang=ts&"
export * from "./KBInvoicesBrands.vue?vue&type=script&lang=ts&"
import style0 from "./KBInvoicesBrands.vue?vue&type=style&index=0&id=686f5f4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
